import useWebappTracking from '@clearscore/hooks.use-webapp-tracking';

export const constants = {
    BUTTON_TRACKING_TYPES: {
        CTA: 'cta_clicked',
        DISMISS: 'dismiss',
    },
};

export default () => {
    const track = useWebappTracking();

    return {
        trackModalOpen: () =>
            track({
                name: 'fe_offers_exclusive_offers_details_viewed',
                props: {
                    path: '/offers#exclusive-offers-details',
                },
            }),
        trackCtaClick: ({ ctaType, destination, ctaCopy }) =>
            track({
                name: 'fe_offers_exclusive_offers_details_clicked',
                props: {
                    destination_url: destination,
                    cta_copy: ctaCopy,
                    action: ctaType,
                },
            }),
    };
};
